export default __webpack_public_path__ + "static/media/photo.63d97a37.png";